import { Box, Button, Typography } from "@mui/material";
import { ErrorIcon, HomeIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FallbackProps } from "react-error-boundary";

export const ApplicationErrorPage: React.FunctionComponent<FallbackProps> = (props) => {
  const { error } = props;
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.Errors.ApplicationError.Title)}>
      <EmptyPage
        icon={<ErrorIcon />}
        title={t(Resources.Errors.ApplicationError.Title)}
        subtitle={t(Resources.Errors.ApplicationError.Subtitle)}
        actions={
          <UnstyledLink to="/">
            <Button startIcon={<HomeIcon />} variant="contained">
              {t(Resources.Errors.ApplicationError.Home)}
            </Button>
          </UnstyledLink>
        }
      />

      {(error?.name || error?.message) && (
        <Box width={"100%"} mt={Spacing.XXXL} p={Spacing.XXL} textAlign={"center"} sx={{ borderTop: "1px solid", borderColor: "divider" }}>
          <Typography>Detailed error info:</Typography>
          <pre>
            <code>{JSON.stringify(error?.name)}</code>
          </pre>
          <pre>
            <code>{JSON.stringify(error?.message)}</code>
          </pre>
        </Box>
      )}
    </UnauthenticatedLayout>
  );
};
